import React, { useState, useEffect, useRef } from "react";

// fontSize / width / height come from timeMatchLayout.js (clockBox), so the
// display fills exactly the box the board planned for it.
const DigitalClock = ({
  initialTime,
  showSeconds = false,
  hour24 = false,
  fontSize,
  width,
  height,
}) => {
  const timeFormatOptions = {
    hour: "2-digit",
    minute: "2-digit",
    second: showSeconds ? "2-digit" : undefined,
    hour12: !hour24,
  };
  const locale = hour24 ? "en-GB" : "en-US";

  const [time, setTime] = useState(() => new Date(initialTime));
  const [formattedTime, setFormattedTime] = useState(() =>
    new Date(initialTime).toLocaleTimeString(locale, timeFormatOptions)
  );
  const timerRef = useRef(null);

  useEffect(() => {
    setTime(new Date(initialTime));
    setFormattedTime(
      new Date(initialTime).toLocaleTimeString(locale, timeFormatOptions)
    );

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTime((prevTime) => {
        const newTime = new Date(prevTime.getTime() + 1000);
        setFormattedTime(newTime.toLocaleTimeString(locale, timeFormatOptions));
        return newTime;
      });
    }, 1000);

    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, [initialTime]);

  return (
    <div
      className="digital-clock-display digital-clock-display--fluid"
      style={{ fontSize, width, height }}
    >
      {formattedTime}
    </div>
  );
};

export default DigitalClock;
